// :cow: Cosmose CONFIDENTIAL :iso:
import { createAction, props } from '@ngrx/store';
import { LocationPreferencesResponse } from '../services/location-preferences.response';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';

export const dashboardLocationPreferencesRequested = createAction('[DASHBOARD LOCATION PREFERENCES] Dashboard Location Preferences Requested', props<{
  clientId: string,
  timePeriod: DateRangeFilter
}>());
export const dashboardLocationPreferencesRequestSucceeded = createAction('[DASHBOARD LOCATION PREFERENCES] Dashboard Location Preferences Request Succeeded', props<{
  locationPreferencesResponse: LocationPreferencesResponse
}>());
export const dashboardLocationPreferencesRequestFailed = createAction('[DASHBOARD LOCATION PREFERENCES] Dashboard Location Preferences Request Failed');

export const filterChanged = createAction('[DASHBOARD LOCATION PREFERENCES] Filter Changed', props<{ filter: string }>());
export const listVisibilityToggled = createAction('[DASHBOARD LOCATION PREFERENCES] List Visibility Toggled', props<{ value: boolean }>());
